import { connect } from 'react-redux'
import GeneralSettingComponent from './component'

const mapStateToProps = state => ({})

const mapDispatchToProps = dispatch => ({})

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(GeneralSettingComponent)